const images = [
  {
    url: 'images/portraits/Fiverr_01_Colormatics_Backdrop_00598_ORANGE (Large).jpg',
    desc: 'It is with pleasure that I will share my knowledge.',
  },
  {
    url: 'images/portraits/Fiverr_04_Trap_Fabrics_Backdrop_00613_ORANGE (Large).jpg',
    desc2: 'I love when I can see my art impact someone in a real world way.',
  },
  {
    url: 'images/portraits/Fiverr_05_Kurt_Backdrop_01752_GREEN (Large).jpg',
    desc3: "Let's make progress together!",
  },
  {
    url: 'images/portraits/Fiverr_06_Kevin_Backdrop_02648_GREEN (Large).jpg',
    desc: 'Work hard, be kind, and amazing things will happen',
  },
  {
    url: 'images/portraits/Fiverr_07_Jimmy_Backdrop_00671_ORANGE (Large).jpg',
    desc2:
      'No one is to blame for your future situation but yourself. If you want to be successful, then become “Successful.”',
  },
  {
    url: 'images/portraits/Fiverr_08_James_Backdop_01402_ORANGE (Large).jpg',
    desc3: 'Everything comes to him who hustles while he waits.',
  },
  {
    url: 'images/portraits/Fiverr_09_April_Backdrop_01646_DARK_GREEN (Large).jpg',
    desc: 'Invest in your dreams. Grind now. Shine later.',
  },
  {
    url: 'images/portraits/Fiverr_12_Romana_Backdrop_02262_v2 (Large).jpg',
    desc2: 'Great things are done by a series of small things brought together',
  },
  {
    url: 'images/portraits/Fiverr_13_Ritika_Background_00682_ORANGE (Large).jpg',
    desc3: 'Leaders can let you fail and yet not let you be a failure.',
  },
  {
    url: 'images/portraits/Fiverr_14_Gabriell1e_Background_01140 (Large).jpg',
    desc: 'Hard work beats talent when talent doesn’t work hard.',
  },
  {
    url: 'images/portraits/Fiverr_14_Gabrielle_Background_01346_ORANGE (Large).jpg',
    desc2: 'When one door of happiness closes, another opens...',
  },
  {
    url: 'images/portraits/Fiverr_15_David_Background_02846_GREEN (Large).jpg',
    desc3: 'The miracle is not that we do this work, but that we are happy to do it.',
  },
];

export default images;
